import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Space } from "antd"

interface Props {
  title: string
  onAdd?: () => void
  addLabel?: string
  onRefresh?: () => void
}

const TitleSection = ({ title, onAdd, addLabel = "New Request", onRefresh }: Props) => {
  return (
    <div className="row mb-3">
      <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
        <h4 className="mb-0" style={{ fontWeight: 600, fontSize: "18px" }}>
          {title}
        </h4>
        {onAdd && (
          <Space>
            <Button type="ghost" icon={<PlusOutlined />} onClick={onAdd} style={{ display: "flex", alignItems: "center" }}>
              {addLabel}
            </Button>
          </Space>
        )}
      </div>
    </div>
  )
}

export default TitleSection
